<h3 class="font-medium text-lg mb-4 text-purple-700">{{ 'Gestión de usuarios' | translate }}</h3>
<div>
    <p class="text-sm text-gray-600 mb-6">{{ 'Información general sobre los usuarios en la plataforma.' | translate }}</p>
    <app-widget-resumen-usuarios>
    </app-widget-resumen-usuarios>
    <app-widget-distribucion-roles>
    </app-widget-distribucion-roles>
</div>

